var _defs, _polygon, _path, _rect, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatingPressLogoPrimary3White(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 332.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "120.15 131.47 117.14 131.47 64.68 65.29 0 65.29 0 273.96 65.59 273.96 65.59 153.82 68.57 153.82 117.14 217.02 120.15 217.02 168.72 153.82 171.7 153.82 171.7 273.96 237.29 273.96 237.29 65.29 172.61 65.29 120.15 131.47"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.05,129.37h-2.07c-7.46-18.18-25.04-28.3-47.7-28.3-41.14,0-74.52,34.88-74.52,88.82s30.71,88.55,74.52,88.55c22.66,0,40.24-9.84,47.7-28.33h2.07v23.85h65.59V105.53h-65.59v23.85ZM354.43,220c-16.39,0-29.21-10.44-29.21-30.4s12.53-30.11,29.21-30.11,28.92,10.44,28.92,30.11-12.82,30.4-28.92,30.4Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 600.66,
    y: 159.49,
    width: 65.9,
    height: 114.48
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M803.38,273.96h65.56v-101.06c0-53.34-24.13-71.83-58.42-71.83-22.06,0-40.83,11.32-47.41,28.3h-2.38v-23.85h-65.56v168.44h65.56v-86.46c0-19.06,8.96-28.02,21.47-28.02,13.13,0,21.18,8.96,21.18,28.33v86.15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1080,105.55h-65.87v23.25h-2.1c-7.46-17.89-25.04-27.73-47.7-27.73-41.12,0-74.52,33.97-74.52,83.46s30.4,81.69,76.31,81.69c25.94,0,43.24-8.65,51.87-26.23l2.69.6c0,23.56-14.63,42.48-50.53,43.98v.02h-24.73v48.34h19.87c1.48.02,3,.05,4.53.02h.33v-.02h10.01c72.71-1.19,99.85-23.47,99.85-96.23V105.55ZM985.2,216.14c-16.39,0-29.21-10.44-29.21-30.42s12.51-30.09,29.21-30.09,28.92,10.44,28.92,30.09-12.82,30.42-28.92,30.42Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 634.97,
    cy: 56.34,
    r: 30.27,
    transform: "translate(146.14 465.49) rotate(-45)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 516.95,
    cy: 30.27,
    r: 30.27
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M548.51,202.11v-53.34h118.03v-43.24h-118.03v-33.66l-65.87,11.91v21.75h-16.7v43.24h16.7v70.04c0,49.48,22.66,59.63,64.09,59.63,14.89,0,31.59-1.19,35.16-2.1v-56.94c-.88.31-5.07.6-14.29.6-14.03,0-19.08-4.17-19.08-17.89Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M600.66,285.91h44.21c12.58,0,20.36,5.96,20.36,15.82s-7.78,15.82-20.29,15.82h-21.52v13.74h-22.75v-45.38ZM623.41,298.1v8.3h14.07c3.31,0,5.25-1.49,5.25-4.08s-1.94-4.21-5.25-4.21h-14.07Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M668.15,285.91h44.41c13.55,0,20.62,4.93,20.62,13.23,0,5.19-2.98,9.33-8.49,11.47,5.12,1.17,7.46,3.89,7.52,8.75.13,4.73.58,9.14,1.94,11.93h-23.15c-.97-2.33-1.17-6.22-1.29-10.76-.06-2.92-1.23-3.95-4.08-3.95h-14.72v14.72h-22.75v-45.38ZM690.9,297.84v7.98h14.72c3.18,0,5.12-1.43,5.12-3.96s-1.94-4.02-5.12-4.02h-14.72Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M736.74,285.91h57.96v12.12h-35.4v5.25h26.06v10.76h-26.06v5.77h35.4v11.48h-57.96v-45.38Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M796.91,316.96h22.3c1.23,3.37,4.99,5.19,11.41,5.19s9.4-1.56,9.4-3.5c0-2.4-4.8-2.98-11.22-3.5-12.77-.97-31.96-1.43-31.96-14.26,0-9.47,10.63-16.27,31.57-16.27,19.38,0,30.92,6.16,33.9,15.88h-21.91c-1.29-3.31-5.19-5.19-11.41-5.19s-8.56,1.49-8.56,3.24c0,2.46,5.38,3.05,12.32,3.63,12.71,1.1,30.73,2.07,30.73,14.13,0,9.59-12.06,16.27-32.35,16.27s-31.51-5.77-34.23-15.62Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M865.51,316.96h22.3c1.23,3.37,4.99,5.19,11.41,5.19s9.4-1.56,9.4-3.5c0-2.4-4.8-2.98-11.22-3.5-12.77-.97-31.96-1.43-31.96-14.26,0-9.47,10.63-16.27,31.57-16.27,19.38,0,30.92,6.16,33.9,15.88h-21.91c-1.29-3.31-5.19-5.19-11.41-5.19s-8.56,1.49-8.56,3.24c0,2.46,5.38,3.05,12.32,3.63,12.71,1.1,30.73,2.07,30.73,14.13,0,9.59-12.06,16.27-32.35,16.27s-31.51-5.77-34.23-15.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatingPressLogoPrimary3White);
export default __webpack_public_path__ + "static/media/MatingPress-Logo_Primary-3-White.d6dfbef4a5e5428dfc69c7eee133f872.svg";
export { ForwardRef as ReactComponent };